import { getConfigValueAsync } from '@pressreader/config';
import { httpGet } from '@pressreader/services';

import { ConfigDto } from './types/config-dto';
import { ResDto } from './types/res-dto';

interface ResParams {
    id: number;
    locale: string;
    ts: string;
    version: number;
    resourceNames?: string[];
    templateNames?: string[];
    omitResources?: boolean;
}

export async function getResources(args?: { resourceNames?: string[]; templateNames?: string[]; locale?: string }) {
    const dto = await getConfigValueAsync<ConfigDto>('res');

    if (!dto) {
        throw new Error('Resources and templates are not found.');
    }

    const { id, locale, ts } = dto;

    const params: ResParams = {
        id,
        locale,
        ts,
        version: 2,
    };
    if (args?.resourceNames) {
        params.resourceNames = args.resourceNames;
    }
    if (args?.templateNames) {
        params.templateNames = args.templateNames;
    }
    if (args?.locale) {
        params.locale = args.locale;
    }

    const result = await httpGet<ResDto>('res', params);

    return { resources: result.res, templates: result.templates };
}

export async function getAllTemplates() {
    const dto = await getConfigValueAsync<ConfigDto>('res');
    if (!dto) {
        throw new Error('Config not available');
    }
    const { id, locale, ts } = dto;
    const params: ResParams = {
        id,
        locale,
        ts,
        version: 2,
        omitResources: true,
    };
    const result = await httpGet<ResDto>('res', params);
    return result.templates ?? {};
}
